<template>
  <div class="ml-4">
    <v-btn color="primary" @click="exportarItens()" small>Exportar</v-btn>
  </div>
</template>

<script setup>
import Api from "@/api/api";

const props = defineProps({
  parametros_utilizados_nos_filtros: {
    type: Object,
    required: true
  },
  cabecalhos: {
    type: Array,
    required: true
  },
});

function dataHoje() {
  const hoje = new Date();
  const dia = String(hoje.getDate()).padStart(2, '0');
  const mes = String(hoje.getMonth() + 1).padStart(2, '0');
  const ano = hoje.getFullYear();
  return `${dia}-${mes}-${ano}`;
}

async function exportarItens() {
  const link_api = 'relatorios/drp-exportar-lista-de-itens';
  
  const params = {
    parametros_utilizados_nos_filtros: JSON.stringify(props.parametros_utilizados_nos_filtros),
    cabecalhos: JSON.stringify(props.cabecalhos),
  }
  
  Api({
    url: link_api, 
    method: 'POST',
    data: params,
    responseType: 'blob',
  })
  .then(response => {
    if (!response.data) {
      throw new Error('Resposta vazia recebida do servidor.');
    }
    
    let fileName = 'RELATORIO-LISTA-PRODUTOS-SEPARACAO-MERCADORIA-' + dataHoje() + '.xlsx';

    const url = window.URL.createObjectURL(new Blob([response.data]));
    
    const link = document.createElement('a');
    
    link.href = url;
    
    link.setAttribute('download', fileName);
    
    document.body.appendChild(link);
    
    link.click();

    document.body.removeChild(link);
    
    window.URL.revokeObjectURL(url);
  })
  .catch(error => {
    console.error('Erro ao fazer o download do arquivo:', error);
    alert('Erro ao fazer o download do arquivo. Verifique o console para mais detalhes.');
  });
}
</script>
